import { useApi } from "@/lib/api"
import { useMemo } from "react"

export interface TaxTypeCanadaPensionPlan {
    Id: number;
    SourceDeductionTypeId: number;
    IsEligible: boolean;
    EmployeeRatePercentage: number;
    EmployerMultiplerPercentage: number;
    MinAge: number;
    MaxAge: number;
    MaxDeductions: number;
    MaxPensionableEarnings: number;
    AnnualExemption: number;
    EmployeeAdditionalRatePercentage: number;
    AdditionalMaxDeductions: number;
  }
  
  export interface TaxTypeCanadaPensionPlan2 {
    Id: number;
    SourceDeductionTypeId: number;
    IsEligible: boolean;
    EmployeeRatePercentage: number;
    EmployerMultiplerPercentage: number;
    MinAge: number;
    MaxAge: number;
    MaxDeductions: number;
    MaxPensionableEarnings: number;
    AnnualExemption: number;
    EmployeeAdditionalRatePercentage: number | null;
    AdditionalMaxDeductions: number | null;
  }
  
  export interface TaxTypeQuebecPensionPlan {
    Id: number;
    SourceDeductionTypeId: number;
    IsEligible: boolean;
    EmployeeRatePercentage: number;
    EmployerMultiplerPercentage: number;
    MinAge: number;
    MaxAge: number;
    MaxDeductions: number;
    MaxPensionableEarnings: number;
    AnnualExemption: number;
    EmployeeAdditionalRatePercentage: number;
    AdditionalMaxDeductions: number;
  }
  
  export interface TaxTypeQuebecPensionPlan2 {
    Id: number;
    SourceDeductionTypeId: number;
    IsEligible: boolean;
    EmployeeRatePercentage: number;
    EmployerMultiplerPercentage: number;
    MinAge: number;
    MaxAge: number;
    MaxDeductions: number;
    MaxPensionableEarnings: number;
    AnnualExemption: number;
    EmployeeAdditionalRatePercentage: number | null;
    AdditionalMaxDeductions: number | null;
  }
  
  export interface TaxTypeEmploymentInsurance {
    Id: number;
    SourceDeductionTypeId: number;
    IsEligible: boolean;
    EmployeeRatePercentage: number;
    EmployerMultiplerPercentage: number;
    MaxEarnings: number;
    MaxInsurable: number;
  }
  
  export interface TaxTypeHealthCare {
    Id: number;
    SourceDeductionTypeId: number;
    IsEligible: boolean;
    EmployeeRatePercentage: number;
  }
  
  export interface ProvincialTaxVersionResponse {
    AvailableStateActions: number[];
    Id: number;
    TaxVersionStatusId: number;
    EffectiveDate: string;
    TD1Minimum: number;
    WCBMaximum: number;
    CanadaEmploymentAmount: number;
    IncomeDeductionRatePercentage: number;
    IncomeDeductionMaximumAmount: number;
    CreatedDatetime: string;
    TaxTypeCanadaPensionPlan: TaxTypeCanadaPensionPlan;
    TaxTypeCanadaPensionPlan2: TaxTypeCanadaPensionPlan2;
    TaxTypeQuebecPensionPlan: TaxTypeQuebecPensionPlan;
    TaxTypeQuebecPensionPlan2: TaxTypeQuebecPensionPlan2;
    TaxTypeEmploymentInsurance: TaxTypeEmploymentInsurance;
    TaxTypeHealthCare: TaxTypeHealthCare;
    // Other fields can be added as needed
  }

/**
 * Hook-based tax API service using the centralized useApi hook
 * Replaces the class-based TaxApiService with hook-based approach
 */
export function useTaxApi() {
  const { mainApi } = useApi()

  /**
   * Get active tax version data for a specific subdivision ID
   * @param subdivisionId - The subdivision ID to fetch tax data for
   * @returns Promise with tax version data including CPP, CPP2, EI rates
   */
  const getActiveCurrentlyEffectiveProvincialTaxVersionBySubdivisionId = async (
    subdivisionId: number
  ): Promise<ProvincialTaxVersionResponse> => {
    const path = `/api/payroll/getActiveCurrentlyEffectiveProvincialTaxVersionBySubdivisionId/${subdivisionId}`
    return mainApi.get<ProvincialTaxVersionResponse>(path)
  }

  return useMemo(() => ({
    getActiveCurrentlyEffectiveProvincialTaxVersionBySubdivisionId,
  }), []);
}
